import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr, API } from "../../lib/api";
import { PageHeader, btnPrimary, EmptyState } from "../../components/bits";
import { FileDown } from "lucide-react";

const STAGES = ["ثانوية", "متوسطة", "ابتدائية", "روضة"];

export default function AdminFortyHours() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/forty-hours").then((r) => setData(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  if (!data) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="admin-forty-page" className="space-y-6">
      <PageHeader title="متجاوزو 40 ساعة تطوعية" sub="إحصائية شاملة لكل من أتم 40 ساعة فأكثر في تعليم الشرقية — الإجمالي وكل مرحلة على حدة">
        <button data-testid="forty-pdf-btn" onClick={() => window.open(`${API}/admin/forty-hours/report`, "_blank")} className={btnPrimary}>
          <FileDown className="w-4 h-4" /> تقرير PDF للطباعة
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <div data-testid="forty-total" className="bg-turq-600 text-white rounded-2xl p-4 text-center shadow-md">
          <div className="font-head font-black text-2xl">{data.total}</div>
          <div className="text-[11px] font-bold opacity-90 mt-0.5">إجمالي المتجاوزين</div>
        </div>
        {STAGES.map((st) => (
          <div key={st} data-testid={`forty-stage-${st}`} className="bg-surface rounded-2xl border border-brd p-4 text-center shadow-sm">
            <div className="font-head font-black text-2xl text-turq-600">{data.by_stage[st] || 0}</div>
            <div className="text-[11px] text-mutext font-bold mt-0.5">{st === "روضة" ? "رياض الأطفال" : st}</div>
          </div>
        ))}
      </div>

      <div className="bg-surface rounded-2xl border border-brd shadow-md overflow-hidden">
        <div className="max-h-[520px] overflow-auto">
          <table className="w-full text-xs">
            <thead className="sticky top-0 z-10">
              <tr className="bg-turq-900 text-white">
                <th className="text-right px-3 py-2.5">#</th>
                <th className="text-right px-3 py-2.5">الاسم</th>
                <th className="text-right px-3 py-2.5">الصف/الفئة</th>
                <th className="text-right px-3 py-2.5">المدرسة</th>
                <th className="text-right px-3 py-2.5">المرحلة</th>
                <th className="text-right px-3 py-2.5">الساعات</th>
              </tr>
            </thead>
            <tbody>
              {data.students.map((s, i) => (
                <tr key={i} data-testid={`forty-row-${i}`} className="border-t border-brd/50 hover:bg-beige-300/50 dark:hover:bg-surface2 transition-colors">
                  <td className="px-3 py-2 text-mutext">{i + 1}</td>
                  <td className="px-3 py-2 font-bold">{s.name}</td>
                  <td className="px-3 py-2">{s.grade}</td>
                  <td className="px-3 py-2">{s.school}</td>
                  <td className="px-3 py-2">{s.stage}</td>
                  <td className="px-3 py-2"><b className="text-coral-600">{s.hours}</b></td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.students.length === 0 && <EmptyState testid="forty-empty" text="لا يوجد متجاوزون لـ 40 ساعة بعد" />}
        </div>
      </div>
    </div>
  );
}
